// <bundle-carousel> — a free side-scroll track that fades only the edge(s)
// that actually overflow. Edge fades are driven by data-overflow-start /
// data-overflow-end attributes the element toggles as it scrolls/resizes.
class BundleCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    this.update = this.update.bind(this);
    this.track.addEventListener('scroll', this.update, { passive: true });
    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(this.update);
      this.ro.observe(this.track);
    }
    this.update();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.update);
    if (this.ro) this.ro.disconnect();
  }

  update() {
    const t = this.track;
    this.toggleAttribute('data-overflow-start', t.scrollLeft > 1);
    this.toggleAttribute('data-overflow-end', t.scrollLeft + t.clientWidth < t.scrollWidth - 1);
  }
}

if (!customElements.get('bundle-carousel')) {
  customElements.define('bundle-carousel', BundleCarousel);
}
